import React from 'react'
import { Outlet } from 'react-router-dom';
import '../styles/style.scss'
import Header from './Header';

export default function Main() {

  return (
    <>
      <div className="container">
        <Header />
        <div className='main'>
          <Outlet />
        </div>
      </div>
    </>
  )
}
